import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import Otp from "../../component/Otp";
import { encode as base64_encode } from "base-64";
import { useNavigate } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import { RolesContext } from "../../context/User";
import NotARobotCheckbox from "../../component/RobotTest";
import IconButton from "@mui/material/IconButton";
import Snackbar from "@mui/material/Snackbar";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Typography from "@mui/material/Typography";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import Button from "@mui/material/Button";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import PopUpConsent from "./PopUpConsent";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

export default function InputAuthorization() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [companyNumber, setCompanyNumber] = useState("");
  const [errorPhone, setErrorPhone] = useState(false);
  const [errorComapny, setErrorComapny] = useState(false);
  const [textValdiation, setTextValidation] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [customerSelect, setCustomerSelect] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [otp, setOtp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [user, setUser] = useState();
  const [urlEncode, setUrlEncode] = useState();
  const [checked, setChecked] = useState(false);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [buttonCheck, setButtonCheck] = useState(true);
  const [stateroles, dispatchroles] = useContext(RolesContext);
  const [addUser, setAddUser] = useState(false);
  const [authMethod, setAuthMethod] = useState("SMS");
  const navigate = useNavigate();

  const validation = (e, type) => {
    if (type == "Check") {
      if (phoneNumber == "") {
        setErrorPhone(true);
      }
      if (companyNumber == "") {
        setErrorComapny(true);
      }
      if (phoneNumber != "" && companyNumber != "") {
        sendForm();
      }
    }
    if (type == "Phone") {
      // If EMAIL method is selected, allow email format, otherwise only digits
      if (authMethod === "EMAIL") {
        setPhoneNumber(e.target.value);
        setErrorPhone(false);
      } else {
        // SMS mode - only accept digits
        if (!/^\d+$/.test(e.target.value)) {
          setErrorPhone(true);
        } else {
          setPhoneNumber(e.target.value);
          setErrorPhone(false);
        }
      }
    }
    if (type == "Company") {
      if (!/^\d+$/.test(e.target.value)) {
        setErrorComapny(true);
      } else {
        setCompanyNumber(e.target.value);
        setErrorComapny(false);
      }
    }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(`/signIn/111`, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.status == 200) {
          navigate(`/portal`);
        }
      } catch (error) {
        if (error.response.status == 404) {
        }
      }
    }
    fetchData();
  }, []);

  const handleChange = (event) => {
    setCustomerSelect(event.target.value);
    setTimeout(() => {
      setOtp(true);
    }, 2000);
  };

  const checkBoxHandle = (checkBox) => {
    if (checkBox == true) {
      setChecked(true);
      setButtonCheck(false);
    } else {
      setChecked(false);
      setButtonCheck(true);
    }
  };

  const openDialogBox = (value) => {
    setOpenDialog(value);
  };

  const closePopup = (value) => {
    setOpenPopUp(value);
  };

  const sendForm = async () => {
    setLoading(true);
    let encoded = base64_encode(`portal~${companyNumber}~${phoneNumber}~${authMethod}`);
    setUrlEncode(encoded);
    try {
      const response = await axios.get(`/signIn/${encoded}`, {
        withCredentials: true,
      });
      let response_data = response.data;
      if (response.status == 200) {
        setUser(response_data);
        setOtp(true);
        setTextValidation("");
        dispatchroles({
          type: "USER_UPDATE",
          payload: {
            value: companyNumber,
            title: "WTAXNUM",
          },
        });
      }
    } catch (error) {
      if (error.response.status == 400) {
        setLoading(false);
        
        // Check if error is EMAIL_NOT_FOUND
        if (error.response.data && error.response.data.error === "EMAIL_NOT_FOUND") {
          // Auto-switch to SMS authentication
          setAuthMethod("SMS");
          setPhoneNumber(""); // Clear the email input
          setTextValidation(error.response.data.message);
          setSnackbarOpen(true);
          setErrorPhone(false);
        } else {
          // Handle other errors
          const errorMessage = typeof error.response.data === 'string' 
            ? error.response.data 
            : error.response.data.message || "אירעה שגיאה";
          setTextValidation(errorMessage);
          setSnackbarOpen(true);
          setAddUser(true);
        }
      }
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const snackbarAction = (
    <>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleSnackbarClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <div>
      <Box
        sx={{
          display: { xs: "none", md: "none", xl: "flex" },
        }}
      >
        <Box
          display={"flex"}
          flexDirection="column"
          alignItems="left"
          sx={{
            marginTop: "3rem",
            marginLeft: "2rem",
            width: otp ? "100%" : "20rem",
          }}
        >
          {!otp ? (
            <>
              <TextField
                label='מספר חברה (ח"פ)'
                className="App"
                variant="outlined"
                error={errorComapny}
                helperText={
                  errorComapny ? "נא לרשום מספרים בלבד" : "נא לרשום 9 ספרות"
                }
                onChange={(e) => validation(e, "Company")}
              />
              
              <FormControl fullWidth sx={{ marginTop: "0.5rem", marginBottom: "0.1rem" }}>
                <InputLabel id="auth-method-label">שיטת אימות</InputLabel>
                <Select
                  labelId="auth-method-label"
                  value={authMethod}
                  label="שיטת אימות"
                  onChange={(e) => setAuthMethod(e.target.value)}
                >
                  <MenuItem value="SMS">SMS</MenuItem>
                  <MenuItem value="EMAIL">דוא״ל</MenuItem>
                </Select>
              </FormControl>

              <TextField
                label={authMethod === "SMS" ? "מספר טלפון" : "כתובת דואר"}
                variant="outlined"
                sx={{ marginTop: "1rem" }}
                value={phoneNumber}
                error={errorPhone}
                helperText={errorPhone && authMethod === "SMS" ? "נא לרשום מספרים בלבד" : ""}
                onChange={(e) => validation(e, "Phone")}
              />
              <FormGroup sx={{ marginTop: "1rem", marginBottom: "0.5rem" }}>
                <FormControlLabel
                  sx={{ width: "110%" }}
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={(event) => checkBoxHandle(event.target.checked)}
                    />
                  }
                  label={
                    <span style={{ fontSize: "12px" }}>
                      קראתי ואני מאשר התחייבותי לעמוד בכל תנאי השימוש. השימוש
                      באתר זה הינו כפוף לתנאי השימוש
                      <Button
                        size="small"
                        style={{ textDecoration: "underline" }}
                        onClick={() => setOpenPopUp(true)}
                      >
                        תנאי השימוש
                      </Button>
                    </span>
                  }
                />
              </FormGroup>
              <LoadingButton
                disabled={
                  buttonCheck ? true : errorComapny || errorPhone ? true : false
                }
                variant="contained"
                color="primary"
                size="medium"
                loading={loading}
                loadingPosition="start"
                startIcon={<SendIcon />}
                onClick={(e) => validation(e, "Check")}
                onKeyDown={(e) => validation(e, "Check")}
              >
              <span>שלח</span>
            </LoadingButton>
            </>
          ) : (
            <Otp
              source={"portal"}
              userData={{
                cust_id: companyNumber,
                Identify: phoneNumber,
                CustID: customerSelect,
              }}
              user={user}
              urlEncode={urlEncode}
              authMethod={authMethod}
            />
          )}
        </Box>
        <Box sx={{ marginTop: "1rem", marginLeft: "2rem", margin: "auto" }}>
          {addUser && !otp ? (
            <Button
              variant="text"
              onClick={() => openDialogBox(true)}
              sx={{ flexDirection: "column", alignItems: "center" }} // Add this line
            >
              {/* <PersonAddIcon sx={{ fontSize: 40, color: "white" }} /> */}
              <PersonAddIcon sx={{ fontSize: 40 }} />
              <Typography
                className="App"
                variant="subtitle1"
                // color="white"
                style={{ padding: "5px" }}
              >
                הוסיפו אותי כאיש קשר
              </Typography>
            </Button>
          ) : null}
        </Box>
      </Box>
      <Box sx={{ display: { xs: "none", md: "flex", xl: "none" } }}>
        <Box
          display={"flex"}
          flexDirection="column"
          alignItems="left"
          sx={{
            marginTop: "1.5rem",
            marginLeft: "2rem",
            width: otp ? "100%" : "20rem",
          }}
        >
          {!otp ? (
            <>
              <TextField
                label='מספר חברה (ח"פ)'
                size="small"
                className="App"
                variant="outlined"
                error={errorComapny}
                helperText={
                  errorComapny ? "נא לרשום מספרים בלבד" : "נא לרשום 9 ספרות"
                }
                onChange={(e) => validation(e, "Company")}
              />

              <TextField
                label={authMethod === "SMS" ? "מספר טלפון" : "כתובת דואר"}
                variant="outlined"
                size="small"
                sx={{ marginTop: "1rem" }}
                value={phoneNumber}
                error={errorPhone}
                helperText={errorPhone && authMethod === "SMS" ? "נא לרשום מספרים בלבד" : ""}
                onChange={(e) => validation(e, "Phone")}
              />

              <FormControl fullWidth size="small" sx={{ marginTop: "1rem", marginBottom: "0.1rem" }}>
                <InputLabel id="auth-method-label-md">שיטת אימות</InputLabel>
                <Select
                  labelId="auth-method-label-md"
                  value={authMethod}
                  label="שיטת אימות"
                  onChange={(e) => setAuthMethod(e.target.value)}
                >
                  <MenuItem value="SMS">SMS</MenuItem>
                  <MenuItem value="EMAIL">דוא״ל</MenuItem>
                </Select>
              </FormControl>
              <FormGroup sx={{ marginTop: "1rem" }}>
                <FormControlLabel
                  style={{ fontSize: "12px" }}
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={(event) => checkBoxHandle(event.target.checked)}
                    />
                  }
                  label={
                    <span style={{ fontSize: "12px" }}>
                      קראתי ואני מאשר התחייבותי לעמוד בכל תנאי השימוש. השימוש
                      באתר זה הינו כפוף לתנאי השימוש
                      <Button
                        size="small"
                        style={{ textDecoration: "underline" }}
                        onClick={() => setOpenPopUp(true)}
                      >
                        תנאי השימוש
                      </Button>
                    </span>
                  }
                />
              </FormGroup>
              <LoadingButton
                disabled={
                  buttonCheck ? true : errorComapny || errorPhone ? true : false
                }
                variant="contained"
                color="primary"
                size="medium"
                loading={loading}
                loadingPosition="start"
                startIcon={<SendIcon />}
                onClick={(e) => validation(e, "Check")}
                onKeyDown={(e) => validation(e, "Check")}
              >
                <span>שלח</span>
              </LoadingButton>
            </>
          ) : (
            <Otp
              source={"portal"}
              userData={{
                cust_id: companyNumber,
                Identify: phoneNumber,
                CustID: customerSelect,
              }}
              user={user}
              urlEncode={urlEncode}
              authMethod={authMethod}
            />
          )}
        </Box>
        <Box sx={{ marginTop: "1rem", marginLeft: "2rem", margin: "auto" }}>
          {addUser && !otp ? (
            <Button
              variant="text"
              onClick={() => openDialogBox(true)}
              sx={{ flexDirection: "column", alignItems: "center" }} // Add this line
            >
              {/* <PersonAddIcon sx={{ fontSize: 40, color: "white" }} /> */}
              <PersonAddIcon sx={{ fontSize: 40 }} />
              <Typography
                className="App"
                variant="subtitle1"
                // color="white"
                style={{ padding: "5px" }}
              >
                הוסיפו אותי כאיש קשר
              </Typography>
            </Button>
          ) : null}
        </Box>
      </Box>
      <Box
        sx={{
          marginTop: "3rem",
          marginLeft: "2rem",
          display: { xs: "block", md: "none" },
          // overflow: "scroll",
        }}
      >
        {!otp ? (
          <>
            <TextField
              label='מספר חברה (ח"פ)'
              className="App"
              variant="outlined"
              sx={{ width: "80vw" }}
              error={errorComapny}
              helperText={
                errorComapny ? "נא לרשום מספרים בלבד" : "נא לרשום 9 ספרות"
              }
              onChange={(e) => validation(e, "Company")}
            />

            <TextField
              label={authMethod === "SMS" ? "מספר טלפון" : "כתובת דואר"}
              sx={{ width: "80vw", marginTop: "2rem" }}
              variant="outlined"
              value={phoneNumber}
              error={errorPhone}
              helperText={errorPhone && authMethod === "SMS" ? "נא לרשום מספרים בלבד" : ""}
              onChange={(e) => validation(e, "Phone")}
            />

            <FormControl sx={{ width: "80vw", marginTop: "1rem", marginBottom: "1rem" }}>
              <InputLabel id="auth-method-label-xs">שיטת אימות</InputLabel>
              <Select
                labelId="auth-method-label-xs"
                value={authMethod}
                label="שיטת אימות"
                onChange={(e) => setAuthMethod(e.target.value)}
              >
                <MenuItem value="SMS">SMS</MenuItem>
                <MenuItem value="EMAIL">דוא״ל</MenuItem>
              </Select>
            </FormControl>
            <div></div>
            <FormGroup sx={{ marginBottom: "0.5rem" }}>
              <FormControlLabel
                style={{ fontSize: "12px" }}
                control={
                  <Checkbox
                    checked={checked}
                    onChange={(event) => checkBoxHandle(event.target.checked)}
                  />
                }
                label={
                  <span style={{ fontSize: "12px" }}>
                    קראתי ואני מאשר התחייבותי לעמוד בכל תנאי השימוש. השימוש באתר
                    זה הינו כפוף לתנאי השימוש
                    <Button
                      size="small"
                      style={{ textDecoration: "underline" }}
                      onClick={() => setOpenPopUp(true)}
                    >
                      תנאי השימוש
                    </Button>
                  </span>
                }
              />
            </FormGroup>
            <LoadingButton
              disabled={
                buttonCheck ? true : errorComapny || errorPhone ? true : false
              }
              variant="contained"
              color="primary"
              size="medium"
              loading={loading}
              loadingPosition="start"
              startIcon={<SendIcon />}
              onClick={(e) => validation(e, "Check")}
              onKeyDown={(e) => validation(e, "Check")}
            >
              <span>שלח</span>
            </LoadingButton>
            <Box sx={{ marginTop: "1rem", marginLeft: "20%" }}>
              {addUser && !otp ? (
                <Button
                  variant="text"
                  onClick={() => openDialogBox(true)}
                  sx={{ flexDirection: "column", alignItems: "center" }} // Add this line
                >
                  {/* <PersonAddIcon sx={{ fontSize: 40, color: "white" }} /> */}
                  <PersonAddIcon sx={{ fontSize: 40 }} />
                  <Typography
                    className="App"
                    variant="subtitle1"
                    // color="white"
                    style={{ padding: "5px" }}
                  >
                    הוסיפו אותי כאיש קשר
                  </Typography>
                </Button>
              ) : null}
            </Box>
          </>
        ) : (
          <Otp
            source={"portal"}
            userData={{
              cust_id: companyNumber,
              Identify: phoneNumber,
              CustID: customerSelect,
            }}
            user={user}
            urlEncode={urlEncode}
            authMethod={authMethod}
          />
        )}
      </Box>
      <NotARobotCheckbox
        openDialog={openDialog}
        openDialogBox={openDialogBox}
        companyNumber={companyNumber}
        phoneNumber={phoneNumber}
      />
      <PopUpConsent openPopUp={openPopUp} closePopup={closePopup} />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={textValdiation}
        action={snackbarAction}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
    </div>
  );
}
